module.exports = __webpack_public_path__ + "static/media/card-profile3.3ad71b96.jpg";